import { render, staticRenderFns } from "./CustomerPortraitByMonthChart.vue?vue&type=template&id=532f1900&"
import script from "./CustomerPortraitByMonthChart.vue?vue&type=script&lang=js&"
export * from "./CustomerPortraitByMonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports